import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LocationContext from "../../context/LocationContext";
import HeaderContext from "../../context/HeaderContext";
import Grid from "@mui/material/Grid";
import {
  PlennaHeartIcon,
  StethoscopeIcon,
  CalendarIcon,
  MyGuideIcon,
  HistoryIcon,
} from "../../components/UI/Icons/Icons";
import classes from "./Header.module.css";

const FixedMenu = () => {
  const [selectButton, setSelectButton] = useState(undefined);
  const { currentLocation } = useContext(LocationContext);
  const { userInfo } = useContext(HeaderContext);
  const navigate = useNavigate();

  const menuOptions = [
    {
      title: "Inicio",
      icon: <PlennaHeartIcon />,
      redirect: "/home",
      id: "btnMenuHome",
    },
    {
      title: "Guía",
      icon: <MyGuideIcon />,
      redirect: "/mi-guia?medium=menu",
      id: "btnGuide",
    },
    {
      title: "Citas",
      icon: <StethoscopeIcon />,
      redirect: "/citas?view=citas&medium=menu",
      id: "btnAppointments",
    },
    {
      title: "Agendar",
      icon: <CalendarIcon />,
      redirect: "/especialidades",
      id: "btnSchedule",
    },

    {
      title: "Historia",
      icon: <HistoryIcon />,
      redirect: "/historial-clinico",
      id: "btnHistory",
    },
  ];

  const colorButtonActive = userInfo.mode === "default" ? "#7b1646" : "#5d3881";
  const backgroundButtonActive =
    userInfo.mode === "default" ? "#f7eeee" : " #eae6ff";

  useEffect(() => {
    menuOptions.forEach((option) => {
      if (option?.redirect?.includes(currentLocation?.pathname)) {
        setSelectButton(option.id);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocation]);

  return (
    <div className={classes.fixedMenu}>
      <div className={classes.containerFixedButtons}>
        {menuOptions.map((option, index) => {
          return (
            <button
              key={index}
              className={classes.buttonFixedMenu}
              onClick={() => {
                navigate(option.redirect);
              }}
            >
              <Grid
                item
                display={"flex"}
                justifyContent={"center"}
                style={{
                  color:
                    selectButton === option.id ? colorButtonActive : "#A0A0A0",
                  backgroundColor:
                    selectButton === option.id ? backgroundButtonActive : null,
                  padding: "8px 24px",
                  borderRadius: "16px",
                }}
              >
                {option.icon}
              </Grid>
              <Grid
                item
                display="flex"
                justifyContent="center"
              >
                <p>{option.title}</p>
              </Grid>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FixedMenu;
